import React from 'react';

const Banner = () => {
  return(
  <div className='BannerStyle'>
    <h1>Latest & Greatest!</h1>
    <p>Here you can find alot of awesome projects or videos all based around GatsbyJS. GatsbyFinds is in no way linked to GatsbyJS nor any project or video that you see on here we are just fans of GatsbyJS.</p>
  </div>
  );
}
export default Banner;
